import {Component, EventEmitter, Input, Output} from '@angular/core';
import swal from 'sweetalert2';
import {ServicesService} from '../../services/services.service';
const defaultImage = require('../../../assets/img/boxed-bg.jpg');

const readAsDataUrl = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', function () {
      // convert image file to base64 string
      resolve(reader.result);
    }, false);
    reader.readAsDataURL(file);
  });
};

const selectFile = () => {
  return new Promise((resolve, reject) => {
    let handled = false;
    const input = document.createElement('input');
    input.type = 'file';
    input.id = `ImgBoxComponent.${Date.now()}`;
    document.body.appendChild(input);

    const onFocus = () => {
      window.removeEventListener('focus', onFocus);
      setTimeout(() => {
        if (!handled) { reject('No file selected'); }
        input.remove();
      }, 500);
    };
    window.addEventListener('focus', onFocus);

    const onChange = () => {
      handled = true;
      input.removeEventListener('change', onChange);
      const [file] = Array.from(input.files || []);
      console.log('file', file);
      readAsDataUrl(file).then( dataUrl => resolve({dataUrl, file}));
    };
    input.addEventListener('change', onChange);
    input.click();
  });
};

@Component({
  selector: 'app-img-box',
  templateUrl: './img-box.component.html',
  styleUrls: ['./img-box.component.scss'],
})
export class ImgBoxComponent {
  @Input() textBox: boolean;
  @Input() src: any;
  @Input() identifier: string;
  @Input() deliveryId: number;

  @Output() uploaded = new EventEmitter();

  public defaultImage = defaultImage;
  public uploading = false;

  constructor( private _services: ServicesService) {}

  imageModalShow(image, ev) {
    if (ev) {
      ev.preventDefault();
      ev.target.blur();
    }
    swal({
      title: 'Delivery',
      html: '<img src="' + image + '" class="img-responsive">',
      showCancelButton: false,
      showConfirmButton: false
    });
  }

  uploadImage(ev) {
    if (ev) {
      ev.preventDefault();
      ev.target.blur();
    }

    selectFile().then(({file, dataUrl}) => {
      swal({
        title: 'Confirm upload',
        html: '<img src="' + dataUrl + '" class="img-responsive">',
        showCancelButton: true,
        showConfirmButton: true
      }).then((response) => {
        if (response.dismiss) { return; }

        this.uploading = true;
        const path = 'update-delivery-attachment';
        // const payload = {delivery_id: this.deliveryId, [this.identifier]: dataUrl};
        const fd = new FormData();
        fd.append('delivery_id', this.deliveryId.toString());
        fd.append('name', this.identifier);
        fd.append('file', file);
        this._services.postRequest(fd, path).subscribe((data: any) => {
          if (this._services.checkToken(data.status)) {
            // success
            this.uploaded.emit(data[this.identifier]);
          }
        }).add(() => {
          this.uploading = false;
        });
      });
    }).catch(err => console.log(err.toString()));
  }
}
